import { CreateAttachmentError } from '../types/CreateAttachmentError';
import AttachmentInfoResponseMessage from 'owa-service/lib/contract/AttachmentInfoResponseMessage';
import { trace } from 'owa-trace';

/**
 * Creates an error message from the unsuccessfull response from the server
 * to be thrown by the caller
 * @param response The response message received from the server
 */
export function getErrorForAttachmentCreationFailure(
    responseMessage: AttachmentInfoResponseMessage
): CreateAttachmentError {
    let errorMessage = 'Attachment: createAttachment failed';
    let errorCode = 'genericError';
    if (responseMessage && responseMessage.MessageText) {
        errorMessage += ` with MessageText: ${responseMessage.MessageText}`;
    }
    trace.warn(errorMessage);

    if (responseMessage && responseMessage.ResponseCode) {
        errorCode = responseMessage.ResponseCode;
    }
    return {
        errorMessage: errorMessage,
        errorCode: errorCode,
    };
}
